import InternationalPhoneInput from './components/InternationalPhoneInput';
import PhoneInputMask from './components/PhoneInputMask';

new InternationalPhoneInput();
new PhoneInputMask();
